import { useId } from 'react'
import './BrandLoader.css'

/** Loader animado de marca (colisión central con efecto gooey).
 *  `size` = px del SVG; `label` muestra texto debajo. Usa `currentColor`, así que
 *  hereda el color del contexto (visible en claro/oscuro). */
export function BrandLoader({ label, size = 96, color = '#1d1d1b', className = '' }: {
  label?: string
  size?: number
  color?: string
  className?: string
}) {
  // id único por instancia (sin ':' para que url(#id) sea válido).
  const filterId = `gooey-${useId().replace(/:/g, '')}`
  return (
    <div className={`brand-loader-wrap ${className}`} role="status" aria-label={label ?? 'Cargando'}>
      <svg width={size} height={size} viewBox="0 0 193.16 193.16" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id={filterId} x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" colorInterpolationFilters="sRGB">
            <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="gooey" />
            <feComposite in="SourceGraphic" in2="gooey" operator="atop" />
          </filter>
        </defs>
        <g
          className="brand-loader__group"
          style={{ filter: `url(#${filterId})` }}
          transform="translate(22.66,13.52) scale(1)"
          fill={color}
        >
          <path className="brand-loader__element brand-loader__element--large-circle" d="M84.87,135.09c0-17.32,14.01-31.26,31.39-31.24,16.86.01,30.83,14.06,30.97,31.15.14,16.94-13.82,31.01-30.88,31.12-17.48.12-31.49-13.69-31.48-31.03Z" />
          <path className="brand-loader__element brand-loader__element--small-circle" d="M23.17,5.52c10.12.07,18.32,8.38,18.26,18.48-.07,10.43-8.35,18.44-18.92,18.29-10.1-.14-18.26-8.58-18.04-18.68.22-10.11,8.55-18.17,18.7-18.09Z" />
          <path className="brand-loader__element brand-loader__element--swoosh" d="M17.58,135.1s0-.04.01-.06c11.99,6.46,27.18,5.21,37.85-4.27,6.9-6.13,10.78-15.79,12.71-35.67l.03.03c.46-4.01,2.34-7.87,5.59-10.76,3.35-2.97,7.54-4.38,11.68-4.27h0c26.73.65,40.08-2.27,48.92-10.12,16.55-14.69,18.06-40.11,3.37-56.66-3.19-3.6-6.89-6.48-10.9-8.64,0,.02,0,.05-.01.07-14.4-7.7-32.71-6.1-45.62,5.36-8.84,7.84-13.32,20.76-15.83,47.38h0c-.46,4.01-2.34,7.87-5.59,10.76-3.3,2.93-7.44,4.34-11.53,4.27-19.93-.31-30.27,2.13-37.18,8.27-13.68,12.15-14.83,33.26-2.56,47.08,2.67,3,5.75,5.41,9.08,7.23Z" />
        </g>
      </svg>
      {label && <span className="brand-loader__label">{label}</span>}
    </div>
  )
}
